<template>
    <div class="page-content">

        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.couponList.title')"></div>
        <!--    页面标题 end -->


        <Row type="flex" justify="center">
            <!--        侧边栏 start -->
            <i-col :lg="4">
                <SideBar class="mobile-no-sidebar" />
            </i-col>
            <!--        侧边栏 end -->

<!--            优惠券列表 start-->
            <i-col :xs="24" :md="24" :lg="12">
                <Coupon :handle-use-coupon="gotoBookRoom" />

            </i-col>
<!--            优惠券列表 end-->

        </Row>


    </div>
</template>

<script>

  import SideBar from "../../components/SideBar/SideBar";
  import {mapMutations, mapState} from "vuex";
  import {getLocalLang, gotoPage, urlRequest} from "../../common/common";
  import Coupon from "../../components/coupon/Coupon";

  export default {
    name: "CouponList",

    data() {
      return {

        // 是否展示优惠券对兑对话框
        isShowRedeemModal: false,
        // 选中的可兑换优惠券下标
        selectedCouponIndex: 0,
        // 可用优惠券列表
        availableCouponList: [],
        // 可兑换优惠券列表
        redeemableCouponList: [{integral: 0, name: ''}],

      }
    },

    created() {

      // 加载数据
      // this.loadData();

    },

    methods: {

      // 跳转去房间列表页面
      gotoBookRoom() {
        gotoPage({
          path: '/RoomList'
        });
      },

    },

    components: {
      Coupon,
      SideBar,
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "CouponList.scss";

</style>
